import company from "./company";

export default function*() {
    yield* [...company];
}
